import React, { Fragment, useEffect, useState } from "react";

import { Button, Img, Line, List, Text } from "components";
import ContextMenu from "components/ContextMenu";
import Footer1 from "components/Footer1";
import InfoRibbon from "components/InfoRibbon";
import { useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { addToCart, cartChanges, getAllCarts, totalAmountInCarts, totalItemsInCarts } from "../../states/cart.mjs";
import { MoreProducts } from "../../components/MoreProducts";
import { scrollToTop } from "../../helpers/scroll";
import { formatCurrency } from "../../helpers/number";
import { CartItem } from "../../components/CartItem";
import { clearSearchKeyword } from "../../states/search.mjs";

const CartReviewPagePage = () => {
  const navigate = useNavigate();
  const [carts, setCarts] = useState([]);
  const [totalCartAmount, setTotalCartAmount] = useState(0);
  const [totalCartItems, setTotalCartItems] = useState(0);


  useEffect(() => {
    const subscription = cartChanges(() => {
      setCarts(getAllCarts());
      setTotalCartAmount(totalAmountInCarts());
      setTotalCartItems(totalItemsInCarts());
    });
    return () => subscription.unsubscribe();
  }, []);

  useEffect(()=>{
    scrollToTop();
    return ()=>{
      clearSearchKeyword();
    }
  },[]);

  return (
    <>
      <div className="bg-white-A700 flex flex-col font-inter items-center justify-start mx-auto w-full">
        <InfoRibbon />
        <Header />
        <ContextMenu />

        {
          carts.length > 0 && <>
            <div className="flex md:flex-col flex-row gap-5 items-start justify-between mt-7 mx-auto px-8 w-full">
              <div className="bg-white-A700 border flex md:flex-1 flex-col items-center justify-start p-[21px] sm:px-5 rounded-lg w-[67%] md:w-full">
                <List
                  className="flex flex-col gap-8 items-center mt-[21px] w-full"
                  orientation="vertical"
                >
                  {
                    carts?.map((cart, index) => {
                      return (
                        <Fragment key={cart?.product?.id ?? index}>
                          <CartItem
                            quantity={cart?.quantity}
                            product={cart?.product}
                            image={cart?.product?.images[0]}
                            amount={cart?.product?.retailPrice}
                            name={cart?.product?.product}
                            description={cart?.product?.description} />
                          {(index + 1) !== carts.length && <Line className="bg-gray-300 mb-8 h-px  mx-auto w-full" />}
                        </Fragment>
                      );
                    })
                  }
                </List>
              </div>
              <div className="bg-white-A700 border sticky top-[120px] flex md:flex-1 flex-col items-center justify-start p-[15px] rounded-lg w-[33%] md:w-full">
                <div className="flex flex-col gap-[22px] items-start justify-start mb-[18px] mt-[7px] w-[99%] md:w-full">
                  <div className="flex flex-col gap-[18px] items-start justify-start">
                    <Text
                      className="text-black-900_dd text-xl tracking-[0.15px]"
                      size="txtInterRegular20"
                    >
                      Sub total ( {totalCartItems} Items )
                    </Text>
                    <div className="flex flex-col items-center justify-start w-[78%] md:w-full">
                      <div className="flex flex-row gap-3 items-start justify-start w-full">
                        <Text
                          className="text-blue_gray-700 text-xs tracking-[0.40px]"
                          size="txtInterRegular12"
                        >
                          TZS
                        </Text>
                        <Text
                          className="text-black-900_dd text-xl tracking-[0.15px]"
                          size="txtInterMedium20"
                        >
                          {formatCurrency(totalCartAmount)}
                        </Text>
                      </div>
                    </div>
                  </div>

                  <Button
                    onClick={() => {
                      // addToCart(selected, 1);
                      navigate("/cartcheckoutadresspage");
                    }}
                    className="!bg-colors3 !rounded-[37px] cursor-pointer flex h-12 items-center justify-center min-w-[300px] mt-[11px]"
                    leftIcon={
                      <Img
                        className="mr-[19px]"
                        src="images/img_payment.svg"
                        alt="Payment"
                      />
                    }
                    shape="circle"
                    color="orange_A200"
                    size="xs"
                    variant="fill"
                  >
                    <div className="text-base text-left tracking-[0.25px]">
                      Proceed to payment
                    </div>
                  </Button>
                </div>
              </div>
            </div>

            <Line className="bg-gray-300 mb-8 h-px mt-[62px] mx-auto w-full" />
          </>
        }
        {/*<MoreProducts*/}
        {/*  actionText={"Add to cart"}*/}
        {/*  onAddToBasket={(element) => {*/}
        {/*    addToCart(element, 1);*/}
        {/*    // toast.success(`${element?.product} added to cart`);*/}
        {/*    scrollToTop(150);*/}
        {/*  }}*/}
        {/*  onSelect={(element) => {*/}
        {/*    navigate("/productdetailpage", {*/}
        {/*      state: { ...element ?? {} }*/}
        {/*    });*/}
        {/*  }}*/}
        {/*/>*/}
        <Footer1 className="bg-blue_gray-900 mt-16 flex flex-col items-center justify-start p-6 sm:px-5 w-full" />
      </div>
    </>
  );
};

export default CartReviewPagePage;
